export default __webpack_public_path__ + "static/predicting-failures--mobile-c1210829da7b4ab38eb547883371375c.webp";